export default "__VITE_ASSET__48f94f2e__"